const normalize = value => String(value || '').trim().toLowerCase();

// Resolve persisted/display names against master data before they reach requests.
export default function canonicalLocation(location, cities = []) {
  if (!location) return location;
  const name = normalize(location.city);
  const city = cities.find(item => name && (normalize(item.name) === name || normalize(item.name_ar) === name))
    || cities.find(item => String(item.id) === String(location.cityId));
  if (!city) return location;
  return {...location, cityId: city.id, city: city.name, cityAr: city.name_ar || '', stateId: city.state_id || ''};
}
